import { PointMapName as View } from 'ui-components'

import { useIsEmbedding } from '~map-preview/hooks/useIsEmbedding'
import {
  useInfographicTitle,
  useIsInfographic
} from '~map-preview/states/infographic'
import { useMap } from '~map-preview/states/map'

const MapName = (props) => {
  const map = useMap()
  const isEmbedding = useIsEmbedding()

  const isDefaultName = map?.name === 'Default Map Name'
  const isInforgraphic = useIsInfographic()
  const showTitle = useInfographicTitle()

  const render = isInforgraphic && (isDefaultName || isEmbedding || showTitle)

  if (!render) return null

  return (
    <View
      {...props}
      name={map?.name}
    />
  )
}

export { MapName }
